import Icon from "components/Activities/Icon";
import _ from "lodash";
import React, { memo } from "react";
import { Link } from "react-router-dom";
import { CreateSigner, DeclineSigner, SignSigner } from "../Items";
import ActivityItemDom from "./ActivityItemDom";

interface Props {
	activity: tcpinpoint.ActivityItem;
}

const ActivitySignerItem = ({ activity }: Props) => {
	const props = { key: activity.attributes.item.id, activity };
	// Prefer linking to the project's conditions tab via the activity target
	// (the condition's task). Fall back to the form document for legacy
	// activities published before the task target was included.
	const taskId = _.get(activity.attributes.item, "target.id");
	const formId = _.get(activity.attributes.item.subject, "id");
	const link = taskId ? `/tasks/${taskId}#conditions` : formId ? `/forms/${formId}` : "#";
	let output;
	let icon;

	switch (activity.attributes.item.type) {
		case "Create":
			icon = Icon("create-party");
			output = <CreateSigner {...props} />;
			break;
		case "Reject":
			icon = Icon("delete-party");
			output = <DeclineSigner {...props} />;
			break;
		case "Update":
			icon = Icon("accept-condition");
			output = <SignSigner {...props} />;
			break;
	}

	return (
		<Link to={link} className="activity-item-link">
			{" "}
			<ActivityItemDom activity={activity} icon={icon} link={link} output={output} />
		</Link>
	);
};

export default memo(ActivitySignerItem);
